import React from 'react';
import { motion } from 'framer-motion';

const LoseScreen = ({ trainingType, currentImageIndex = 0 }) => {
  const getImageUrl = () => {
    switch(trainingType) {
      case 'fashion':
        return `https://processed.portal.soot.com/playground-static-assets/fashion${currentImageIndex + 1}.png`;
      case 'product':
        return `https://processed.portal.soot.com/playground-static-assets/product${currentImageIndex + 1}.png`;
      case 'nature':
      default:
        return `https://processed.portal.soot.com/playground-static-assets/wildlife${currentImageIndex + 1}.png`;
    }
  };
  
  return (
    <motion.div 
      className="fixed inset-0 flex flex-col items-center justify-center bg-red-600"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.div 
        className="text-8xl font-bold mb-8 text-white"
        style={{ fontFamily: 'ABC Diatype Rounded Medium' }}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        TIME'S UP!
      </motion.div>
      <motion.div
        className="w-64 h-64 rounded-xl overflow-hidden shadow-lg grayscale"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        <img
          src={getImageUrl()}
          alt="Lost"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <motion.div 
        className="text-4xl font-bold mt-8 text-white opacity-75"
        style={{ fontFamily: 'ABC Diatype Rounded Medium' }}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        YOU LOSE
      </motion.div>
    </motion.div>
  );
};

export default LoseScreen;